<template>
  <div>
    <p v-text="getFirstDate"></p>
    <p v-text="getLastDate"></p>
    <p v-html="getLastTemp"></p>
    <p v-text="getLastHumid"></p>
  </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        props: ['temperatureData'],
        data: function () {return {}},
        created() {},
        computed: {
            getFirstDate: function () {
                if (this.temperatureData.length > 0 && this.temperatureData[0].hasOwnProperty('timestamp')) {
                    return this.getDate(this.temperatureData[0]);
                }
                return '';
            },
            getLastDate: function () {
                if (this.temperatureData.length > 0 && this.temperatureData[this.temperatureData.length-1].hasOwnProperty('timestamp')) {
                    return this.getDate(this.temperatureData[this.temperatureData.length-1]);
                }
                return 'loading';
            },
            getLastTemp: function () {
                if (this.temperatureData.length > 0 && this.temperatureData[this.temperatureData.length-1].hasOwnProperty('temperature')) {
                    return this.getTemp(this.temperatureData[this.temperatureData.length - 1]);
                }
                return '';
            },
            getLastHumid: function () {
                if (this.temperatureData.length > 0 && this.temperatureData[this.temperatureData.length-1].hasOwnProperty('humidity')) {
                    return this.getHumid(this.temperatureData[this.temperatureData.length - 1]);
                }
                return '';
            }
        },
        methods: {
            getDate: function (item) {
                if (item.hasOwnProperty('timestamp')) {
                    const date = new Date(item['timestamp'] * 1);
                    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'};

                    return date.toLocaleDateString('de-CH', options);
                }
                return 'loading';
            },
            getTemp: function (item) {
                if (item.hasOwnProperty('temperature')) {
                    return item['temperature'] + '&nbsp;&deg;C';
                }
                return '';
            },
            getHumid: function (item) {
                if (item.hasOwnProperty('humidity')) {
                    return item['humidity'] + '%';
                }
                return '';
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>
